import * as React from "react";
import type { SVGProps } from "react";
const Constructor = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#clip0_4355_7451)">
      <g clipPath="url(#clip1_4355_7451)">
        <path
          fill="currentColor"
          d="M11.6667 2.667a1.332 1.332 0 0 0-1.3334 1.3333v4.2459a.4197.4197 0 0 1-.4208.4208.42.42 0 0 1-.3667-.2125l-2-3.4958c-3.0875 1.5208-5.2125 4.7-5.2125 8.375v2.6666h21.3334v-2.7666c-.0375-3.6334-2.1542-6.7667-5.2125-8.275l-2 3.4958a.42.42 0 0 1-.3667.2125.4197.4197 0 0 1-.4208-.4208V4.0003a1.332 1.332 0 0 0-1.3334-1.3333zm-9.975 14.6667A.69.69 0 0 0 1 18.0253c0 .1959.0833.3834.2417.4959.9041.6625 4.4166 2.8125 11.7583 2.8125s10.8542-2.15 11.7583-2.8125c.1584-.1167.2417-.3.2417-.4959a.69.69 0 0 0-.6917-.6916z"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_4355_7451">
        <path fill="transparent" d="M0 0h24v24H0z" />
      </clipPath>
      <clipPath id="clip1_4355_7451">
        <path fill="transparent" d="M1 1.3335h24v21.3333H1z" />
      </clipPath>
    </defs>
  </svg>
);
export default Constructor;
